__turbopack_context__.v({
  "body": "typography-module__uz8gEG__body",
  "subtitle": "typography-module__uz8gEG__subtitle",
  "title": "typography-module__uz8gEG__title",
});
